import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
    activeProvidersAtom,
    showBrowseModalAtom,
    showProvidersAtom,
    userIsLoggedInAtom,
} from "../state/games";
import { useAtom } from "jotai";
import { useTranslation } from "../hooks/hooks";
import { routes } from "../router/Routes";
import {
    AffiliateIcon,
    BuyWinIcon,
    FavoritesIcon,
    LiveSupportIcon,
    MoreGamesIcon,
    NewGamesIcon,
    OtherGamesIcon,
    PromotionsIcon,
    ProvidersIcon,
    ResponsibleGamblingIcon,
    VIPIcon,
    WinDashboardIcon,
    WinStakingIcon,
} from "./Icons";
import Icon from "./Icon";
import { getCategoryIcon, getExternalLink, scrollToTop } from "../helpers/helpers";
import { useNavigate } from "react-router-dom";
import { Category } from "../interfaces/intefaces";
import Search from "./Search";
import {
    CategoriesEndpointUrl,
    CATEGORYTYPE_CASINO,
    CATEGORYTYPE_LIVECASINO,
} from "../config/consts";
import axios from "axios";

const style = {
    backgroundColor: "#0f1432",
    borderRadius: "10px",
    padding: "15px",
    color: "#fff",
    marginBottom: "10px",
    ".mobilemenu-item  > div": {
        display: "flex",
        marginBottom: "10px",
        alignItems: "flex-end",
        svg: {
            width: "20px",
            height: "20px",
            marginRight: "10px",
        },
        ".title": {
            lineHeight: "20px",
            display: "block",
        },
    },
    ".mobilemenu-item:last-child  > div:not(last-child)": {
        marginBottom: 0,
    },
};

interface IProps {
    categories: Category[];
    activeCategory: number;
    updateCategory: (category_id: number) => void;
    setCategoryType: (categoryType: number) => void;
}
export default function ModalMobileMenu({
    categories,
    activeCategory,
    updateCategory,
    setCategoryType,
}: IProps) {
    const [showModal, setShowModal] = useAtom(showBrowseModalAtom);
    const { _e } = useTranslation();
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const favorites = location.pathname === routes.pages.favorites ? 1 : 0;
    const navigate = useNavigate();
    const [, setActiveProviders] = useAtom(activeProvidersAtom);
    const newGames = location.pathname === routes.pages.new ? 1 : 0;
    const [showProviders, setShowProviders] = useAtom(showProvidersAtom);
    const [casinoCategories, setCasinoCategories] = useState<Category[] | null>([]);
    const [liveCasinoCategories, setLiveCasinoCategories] = useState<Category[] | null>([]);

    const handleLinkClick = (route: string, category: number, categoryType: number) => {
        window.location.href =
            categoryType === CATEGORYTYPE_LIVECASINO ? `/live-casino/#${route}` : `/#${route}`;
        scrollToTop();
        setActiveProviders([]);
        updateCategory(category);
        categoryType && setCategoryType(categoryType);
        navigate(route);
        setShowModal(false);
    };
    const [error, setError] = useState({ message: null });

    useEffect(() => {
        const fetchCasinoCategories = async (callback: any, errorCallback: any) => {
            const url = CategoriesEndpointUrl;
            const returnedData = await axios
                .get(url, { params: { categoryType: 1 } })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        const fetchLiveCasinoCategories = async (callback: any, errorCallback: any) => {
            const url = CategoriesEndpointUrl;
            const returnedData = await axios
                .get(url, { params: { categoryType: 2 } })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };

        fetchCasinoCategories(setCasinoCategories, setError);
        fetchLiveCasinoCategories(setLiveCasinoCategories, setError);
    }, []);
    return (
        <div>
            <Modal
                sx={{
                    position: "fixed",
                    top: "67px",
                    bottom: "50px",
                    left: 0,
                    right: 0,
                    backgroundColor: "#273581",
                    padding: "20px 40px",
                    overflow: "auto",
                }}
                open={showModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <>
                    <Search />
                    <Box sx={{ ...style, marginTop: "20px" }}>
                        <div
                            title={_e("Favourites")}
                            className={
                                favorites
                                    ? "mobilemenu-item category favorites active"
                                    : "mobilemenu-item category favorites"
                            }
                            onClick={() => {
                                if (userIsLoggedIn) {
                                    handleLinkClick(routes.pages.favorites, 0, 0);
                                }
                            }}
                        >
                            <div className={!userIsLoggedIn ? "inactive" : ""}>
                                <Icon icon={FavoritesIcon} />
                                <span>{_e("Favourites")}</span>
                            </div>
                        </div>
                        <div
                            title={_e("New Games")}
                            data-slug="new"
                            className={
                                newGames
                                    ? "mobilemenu-item category  active"
                                    : "mobilemenu-item category"
                            }
                            onClick={() => {
                                handleLinkClick(routes.pages.new, 0, 0);
                            }}
                        >
                            <div>
                                <Icon icon={NewGamesIcon} />
                                <span>{_e("New games")}</span>
                            </div>
                        </div>
                    </Box>

                    <Box sx={style}>
                        {casinoCategories?.map(category => {
                            return (
                                <div
                                    className={
                                        activeCategory === category.id
                                            ? `mobilemenu-item category ${category.slug} active`
                                            : `mobilemenu-item category ${category.slug}`
                                    }
                                    key={category.id}
                                    data-slug={category.slug}
                                >
                                    <div
                                        title={category.name}
                                        onClick={() => {
                                            handleLinkClick(
                                                `${routes.pages.games}/${category.slug}`,
                                                category.id,
                                                category.type,
                                            );
                                        }}
                                    >
                                        <Icon icon={getCategoryIcon(category.slug)} />
                                        <span className="title">{category.name}</span>
                                    </div>
                                </div>
                            );
                        })}
                        <div
                            className="mobilemenu-item category"
                            onClick={() => {
                                handleLinkClick(`${routes.pages.games}`, 0, CATEGORYTYPE_CASINO);
                            }}
                        >
                            <div title={_e("More Games")}>
                                <Icon icon={MoreGamesIcon} />
                                <span className="title">{_e("More Games")}</span>
                            </div>
                        </div>
                        <div className="mobilemenu-item category" data-slug={"live-casino"}>
                            <div
                                title="Live casino"
                                onClick={() => {
                                    handleLinkClick(`${routes.root}`, 0, CATEGORYTYPE_LIVECASINO);
                                }}
                            >
                                <Icon icon={getCategoryIcon("livecasino")} />
                                <span className="title">Live casino</span>
                            </div>
                        </div>
                        {liveCasinoCategories?.map(category => {
                            return (
                                <div
                                    className={
                                        activeCategory === category.id
                                            ? `mobilemenu-item category ${category.slug} active`
                                            : `mobilemenu-item category ${category.slug}`
                                    }
                                    key={category.id}
                                    data-slug={category.slug}
                                >
                                    <div
                                        title={category.name}
                                        onClick={() => {
                                            handleLinkClick(
                                                `${routes.pages.games}/${category.slug}`,
                                                category.id,
                                                category.type,
                                            );
                                        }}
                                    >
                                        <Icon icon={getCategoryIcon(category.slug)} />
                                        <span className="title">{category.name}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </Box>
                    <Box sx={style}>
                        <div
                            title={_e("Providers")}
                            data-slug="providers"
                            className="mobilemenu-item"
                            onClick={() => {
                                setShowProviders(!showProviders);
                                setShowModal(false);
                            }}
                        >
                            <div>
                                <Icon icon={ProvidersIcon} />
                                <span>{_e("Providers")}</span>
                            </div>
                        </div>
                    </Box>
                    <Box sx={style}>
                        <div
                            title={_e("Promotions")}
                            data-slug="promotions"
                            className="mobilemenu-item"
                            onClick={() => {
                                window.location.href = getExternalLink("promotions");
                            }}
                        >
                            <div>
                                <Icon icon={PromotionsIcon} />
                                <span>{_e("Promotions")}</span>
                            </div>
                        </div>
                    </Box>
                    <Box sx={style}>
                        <div
                            title={_e("Responsible Gaming")}
                            data-slug="responsiblegaming"
                            className="mobilemenu-item"
                            onClick={() => {
                                window.location.href = getExternalLink("responsiblegaming");
                            }}
                        >
                            <div>
                                <Icon icon={ResponsibleGamblingIcon} />
                                <span>{_e("Responsible Gaming")}</span>
                            </div>
                        </div>
                        <div
                            title={_e("Live support")}
                            data-slug="livesupport"
                            className="mobilemenu-item"
                            onClick={() => {
                                window.location.href = getExternalLink("livesupport");
                            }}
                        >
                            <div>
                                <Icon icon={LiveSupportIcon} />
                                <span>{_e("Live support")}</span>
                            </div>
                        </div>
                    </Box>
                </>
            </Modal>
        </div>
    );
}
